//
// 警告框
// ============================================================
import Ns from "./utility";

const Alert = () => new Ns({
    el: ".alert-wrapper",
    eventHandle: {
        type: "click",
        entrust: ".alert-close",
        callback:  function (ev) {
            let alertWrapper = ns(this).parents(".alert-wrapper").addClass("remove");

            setTimeout( () => {
                alertWrapper.remove()
            }, 500);
            return true;
        }
    },
});

module.exports = Alert;


// WEBPACK FOOTER //
// src/js/alert.js